import { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import Alert from "@mui/material/Alert";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import Tooltip from "@mui/material/Tooltip";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { CircularProgress } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import api from "../../api";
import SnackBarComponent from "../../components/SnackBarComponent";
import { getComparator } from "../../components/tableUtils";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import EnhancedTableToolbar from "../../components/EnhancedTableToolbar";
import TableLoadingState from "../../components/TableLoadingState";
import DeleteConfirmDialog from "../../components/DeleteConfirmDialog";
import ImagePreviewCell from "../../components/ImagePreviewCell";
import ExternalLinkCell from "../../components/ExternalLinkCell";
import StatusChip from "../../components/StatusChip";
import StatusToggleSwitch from "../../components/StatusToggleSwitch";
import ImageUploadSection from "../../components/ImageUploadSection";

const headCells = [
  { id: "tag", numeric: false, disablePadding: true, label: "Tag" },
  { id: "title", numeric: false, disablePadding: false, label: "Title" },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "publishedOn",
    numeric: false,
    disablePadding: false,
    label: "Published On",
  },
  {
    id: "resourcelink",
    numeric: false,
    disablePadding: false,
    label: "Resource Link",
  },
  {
    id: "desktopimage",
    numeric: false,
    disablePadding: false,
    label: "Desktop Image",
  },
  {
    id: "mobileimage",
    numeric: false,
    disablePadding: false,
    label: "Mobile Image",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  /*{
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "",
  },*/
];



export default function Featured() {
  const [rows, setRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("tag");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [desktopImg, setDesktopImg] = useState([]);
  const [mobileImg, setMobileImg] = useState([]);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // onChange={(date) => setStartDate(date)}
  // const [publishedOn, setPublishedOn] = React.useState();
  // dialog box
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState("paper");
  const [isLoading, setIsLoading] = useState(true); // Initial loading state
  const [tags, setTags] = useState([]);

  const [newData, setNewData] = useState({
    tag: "",
    title: "",
    description: "",
    publishedOn: "",
    resourceLink: "",
    desktopImage: "",
    mobileImage: "",
    status: "",
  });
  // update | edit
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  // State for Delete Confirmation Dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleInputChange = (e) => {
    setNewData({ ...newData, [e.target.name]: e.target.value });
  };

  const handleDateChange = (date) => {
    setNewData((prevState) => ({
      ...prevState,
      publishedOn: date ? date.format("LL") : "",
    }));
  };

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
    setIsEditing(false); // Open in create mode
    setNewData({
      tag: "",
      title: "",
      description: "",
      publishedOn: "",
      resourceLink: "",
      desktopImage: "",
      mobileImage: "",
      status: "Hidden",
    });
    setDesktopImg([]);
    setMobileImg([]);
  };

  const handleEditClick = () => {
    const selectedRow = rows.find((row) => row.id === selected[0]);
    setNewData({
      tag: selectedRow.tag,
      title: selectedRow.title,
      description: selectedRow.description,
      publishedOn: selectedRow.publishedOn,
      resourceLink: selectedRow.resourceLink,
      desktopImage: selectedRow.image.desktop,
      mobileImage: selectedRow.image.mobile,
      status: selectedRow.status,
    });
    setDesktopImg([
      {
        source: selectedRow.image.desktop, // Existing desktop image URL for preview
        options: {
          type: 'url',
        },
      },
    ]);
    setMobileImg([
      {
        source: selectedRow.image.mobile, // Existing mobile image URL for preview
        options: {
          type: 'url',
        },
      },
    ]);
    setEditingId(selectedRow.id);
    setIsEditing(true); // Open in edit mode
    setOpen(true);
    // Optionally, handle image files if needed
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      // Validate form fields (add more validation as needed)
      if (
        !newData.tag ||
        !newData.title ||
        !newData.description ||
        !newData.publishedOn ||
        !newData.resourceLink
      ) {
        setSnackbarMessage("Please fill all required fields!");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
        return;
      }
      // Validate images
      if (!desktopImg || desktopImg.length === 0 || !desktopImg[0].file) {
        setSnackbarMessage("Please upload a desktop image!");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
        return;
      }

      if (!mobileImg || mobileImg.length === 0 || !mobileImg[0].file) {
        setSnackbarMessage("Please upload a mobile image!");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
        return;
      }

      // Create a FormData object to send files and form data together
      const formData = new FormData();

      // Append text data
      formData.append("tag", newData.tag);
      formData.append("title", newData.title);
      formData.append("description", newData.description);
      formData.append("publishedOn", newData.publishedOn);
      formData.append("resourceLink", newData.resourceLink);
      formData.append("status", newData.status);
      // Append images if they exist
      if (desktopImg.length > 0) {
        // setDesktopImg()
        formData.append("desktopImage", desktopImg[0].file);
      }
      if (mobileImg.length > 0) {
        formData.append("mobileImage", mobileImg[0].file);
      }
      const token = localStorage.getItem("accessToken");
      // Decide whether to create or update data
      if (isEditing) {
        // Update existing data
        await api.put(
          `/api/featured/${editingId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Set the Authorization header
            },
          }
          //`http://localhost:7777/api/featured/${editingId}`,{status:"published"},
          // {
          //   headers: { "Content-Type": "multipart/form-data" },
          // }
        );

        // Show success snackbar
        setSnackbarMessage("Changes saved successfully!");
        setSnackbarSeverity("success");
      } else {
        // Create new data
        await api.post("/api/featured", formData, {
          headers: {
            Authorization: `Bearer ${token}`, // Set the Authorization header
          },
          //headers: { "Content-Type": "multipart/form-data" },
        });

        // Show success snackbar
        setSnackbarMessage("News added successfully!");
        setSnackbarSeverity("success");
      }

      setOpenSnackbar(true);

      // Refresh the table data after submission or edit
      fetchData();

      // Reset form after submission
      setOpen(false); // Close the dialog box
      setSelected([]); // Clear selected items
      setNewData({
        tag: "",
        title: "",
        description: "",
        publishedOn: "",
        resourceLink: "",
      }); // Reset input fields
      setDesktopImg([]); // Clear desktop image
      setMobileImg([]); // Clear mobile image
    } catch (error) {
      console.error(
        "Error creating/editing data:",
        error.response?.data || error
      );

      // Show error snackbar
      setSnackbarMessage(error.response.data.message);
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("accessToken");
    try {
      const response = await api.get("/api/featured", {
        headers: {
          Authorization: `Bearer ${token}`, // Set the Authorization header
        },
      });
      setRows(response.data);
      setIsLoading(false);  // Stop loading spinner
    } catch (error) {
      console.error("Error fetching data:", error);
      const { status, data } = error.response;
      const { message } = data;
      // window.alert(message); // update your setErrorMessage here
      setErrorMessage(message);
      setIsLoading(false);
    }
  };

  const fetchTags = async () => {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await api.get("/api/tags", {
        headers: {
          Authorization: `Bearer ${token}`, // Set the Authorization header
        },
      });
      // Check if the response status is 200 or 201 and data is empty
      setTags(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      const { status, data } = error.response;
      const { message } = data;
      setErrorMessage(message);
    }
  };

  // More option code
  const ITEM_HEIGHT = 48;

  const [anchorEl, setAnchorEl] = useState(null);
  const openMore = Boolean(anchorEl);
  const handleMoreClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMoreClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    fetchData();
    fetchTags();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  // Handle Delete Confirmation Dialog
  const handleDeleteClick = () => {
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("accessToken");
    try {
      await Promise.all(
        selected.map((id) =>
          api.delete(`/api/featured/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Set the Authorization header
            },
          })
        )
      );
      fetchData(); // Refresh data after deletion
      setSelected([]);
      setOpenDeleteDialog(false);

      // Show success snackbar
      setSnackbarMessage("Deleted successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true); // Open snackbar
    } catch (error) {
      console.error("Error deleting data:", error);

      // Show error snackbar
      setSnackbarMessage(error.response.data.message);
      setSnackbarSeverity("error");
      setOpenSnackbar(true); // Open snackbar
    }
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false); // Reset the state to close the snackbar
  };

  const handleDeleteCancel = () => {
    setOpenDeleteDialog(false);
  };
  const [tagError, setTagError] = useState(true);

  const visibleRows = useMemo(
    () => {
      return rows
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    },
    [order, orderBy, page, rowsPerPage, rows]
  );

  return (
    <Box sx={{ width: "100%" }}>
      {/* Snack bar */}
      {openSnackbar && (
        <SnackBarComponent
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose} // Handle the snackbar close
        />
      )}

      <Paper sx={{ width: "100%", mb: 2 }}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          handleClickOpen={handleClickOpen}
          handleEditClick={handleEditClick}
          handleDeleteClick={handleDeleteClick}
        />
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <CircularProgress size="2rem" />
                  </TableCell>
                </TableRow>
              ) : visibleRows.length === 0 ? (
                <>
                  {errorMessage != null ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Alert severity="error">{errorMessage}</Alert>{" "}
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Alert severity="info">No data available.</Alert>{" "}
                      </TableCell>
                    </TableRow>
                  )
                  }

                </>
              ) : (
                visibleRows.map((row, index) => {
                  const isItemSelected = selected.includes(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  {
                    /* {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .sort(getComparator(order, orderBy))
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`; */
                  }

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                      >
                        {row.tag}
                      </TableCell>
                      <TableCell>{row.title}</TableCell>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>{row.publishedOn}</TableCell>
                      <TableCell>
                        <a
                          className="link"
                          href={(row.resourceLink || "").startsWith('http') ? row.resourceLink : `https://${row.resourceLink}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {"Link"}
                          <OpenInNewIcon
                            sx={{
                              fontSize: "1rem", // Smaller icon size
                              marginLeft: "0.3rem",
                            }}
                          />
                        </a>
                      </TableCell>
                      <TableCell>
                        {/* Display the image if available */}
                        <ImagePreviewCell imageUrl={row.image.desktop} alt="Desktop Image" />
                      </TableCell>
                      <TableCell>
                        <ImagePreviewCell imageUrl={row.image.mobile} alt="Mobile Image" />
                      </TableCell>
                      <TableCell>
                        {/* {row.status} */}
                        <Chip
                          label={
                            row.status === "published"
                              ? "visible"
                              : "not visible"
                          }
                          color={
                            row.status === "published" ? "success" : "warning"
                          }
                          variant="contained"
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Create/Edit Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="dialog-title"
        fullWidth
      >
        <DialogTitle id="dialog-title">
          {isEditing ? "Edit" : "Add"}
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{ "& > :not(style)": { mt: 1.5, mb: 1.5, width: "100%" } }}
            noValidate
            autoComplete="off"
          >
            {/* <FormControl fullWidth>
             */}
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Tag</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Tag"
                name="tag"
                value={newData.tag}
                onChange={handleInputChange}
              >
                {tags.map((element) => {
                  return <MenuItem value={element.tag_title}>{element.tag_title}</MenuItem>
                })
                }
              </Select>
            </FormControl>
            {/* <TextField
              // error
              // error={newData.tag === "" ? true : false}
              autoFocus
              margin="dense"
              name="tag"
              label="Tag"
              type="text"
              fullWidth
              value={newData.tag}
              onChange={handleInputChange}
            /> */}
            <TextField
              //error
              // error={newData.title === "" ? true : false}
              margin="dense"
              name="title"
              label="Title"
              type="text"
              fullWidth
              value={newData.title}
              onChange={handleInputChange}
            />
            <TextField
              //error
              // error={newData.description === "" ? true : false}
              margin="dense"
              name="description"
              label="Description"
              type="text"
              multiline
              rows={3}
              fullWidth
              value={newData.description}
              onChange={handleInputChange}
            />
            {/* published on */}
            {/* {"Published On: " + newData.publishedOn} */}
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateField
                label="Date Of Publish"
                format="LL"
                onChange={handleInputChange}
              />
            </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  label="Date Of Publish"
                  value={newData.publishedOn ? dayjs(newData.publishedOn) : null}
                  // value={dayjs(newData.publishedOn) || null}
                  onChange={handleDateChange}
                  sx={{ width: '100%' }} // Adjust width here
                />
              </DemoContainer>
            </LocalizationProvider>
            <TextField
              //error
              // error={newData.title === "" ? true : false}
              margin="dense"
              name="resourceLink"
              label="Resource Link"
              placeholder="https://example.com/resource"
              type="text"
              fullWidth
              value={newData.resourceLink}
              onChange={handleInputChange}
            />
          </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <FormControlLabel
              control={
                <Switch
                  // CHECKED if status is "published", UNCHECKED if "Hidden"
                  checked={newData.status === "published"}

                  // ON CHANGE: Toggle between the two string values
                  onChange={(e) =>
                    setNewData({
                      ...newData,
                      status: e.target.checked ? "published" : "Hidden",
                    })
                  }
                  color="success"
                />
              }
              // Dynamic Label: Shows "Published" or "Hidden" based on state
              label={newData.status === "published" ? "Published" : "Hidden"}
            />
          </Box>
          <Divider
            sx={{ "& > :not(style)": { mt: 1.5, mb: 1.5, width: "100%" } }}
          >
            <Chip label="Upload Images" size="small" />
          </Divider>
          <Box
            component="form"
            sx={{ "& > :not(style)": { mt: 1.5, mb: 1.5, width: "100%" } }}
            noValidate
            autoComplete="off"
          >
            <div>
              {/* Desktop image */}
              <FilePond
                files={desktopImg}
                allowMultiple={false}
                onupdatefiles={setDesktopImg}
                //labelIdle='Drag & Drop image (Desktop) or <span class="filepond--label-action">Browse</span>'
                labelIdle='Desktop Image <br /> <span class="filepond--label-action">Browse</span>'
                acceptedFileTypes={["image/*"]}
                credits={false}  // This hides the "Powered by PQINA" credits
              />

              {/* Mobile Image */}
              <FilePond
                files={mobileImg}
                allowMultiple={false}
                onupdatefiles={setMobileImg}
                //labelIdle='Drag & Drop image (Mobile) or <span class="filepond--label-action">Browse</span>'
                labelIdle='Mobile image <br /><span class="filepond--label-action">Browse</span>'
                acceptedFileTypes={["image/*"]}
                credits={false}  // This hides the "Powered by PQINA" credits
              />
            </div>
          </Box>
        </DialogContent>
        <DialogActions sx={{ "& > :not(style)": { m: 1.5, width: "100%" } }}>
          <Button variant="contained" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            {isEditing ? "Save" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        {/* <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle> */}
        {/* <DialogContent> */}
        <DialogContent>
          <Typography>
            Are you sure do you want to delete the selected {selected.length}{" "}
            item
            {selected.length > 1 ? "s" : ""}? <br /> This action cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ "& > :not(style)": { m: 1.5, width: "100%" } }}>
          <Button variant="contained" onClick={handleDeleteCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDeleteConfirm}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}